export const PEOPLE_SIDEBAR_VOICE_ICON = {
  LIVE: "live",
  MUTED: "muted"
};

export function getPeopleSidebarVoiceIconKey(micPresence) {
  if (micPresence?.muted) {
    return PEOPLE_SIDEBAR_VOICE_ICON.MUTED;
  }

  if (micPresence) {
    return PEOPLE_SIDEBAR_VOICE_ICON.LIVE;
  }

  return PEOPLE_SIDEBAR_VOICE_ICON.MUTED;
}
